import { HTMLAttributes, ReactNode } from "react";

import { cn } from "../../../lib/utils";

interface TitleProps extends HTMLAttributes<HTMLHeadingElement> {
  children?: ReactNode;
}

export const Title = ({ className, children, ...props }: TitleProps) => (
  <h3
    className={cn(
      "text-xs font-bold uppercase tracking-[0.4em] text-primary",
      className
    )}
    {...props}
  >
    {children}
  </h3>
);
